import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export default (
  message: ReactNode = (
    <FormattedMessage id="form.validations.integer.invalid" />
  ),
) => {
  return (value: any) => {
    if (typeof value === "number") {
      return undefined;
    }

    if (
      value !== undefined &&
      value !== null &&
      (isNaN(value) || value.includes("."))
    ) {
      return message;
    }

    return undefined;
  };
};
